export default "__VITE_ASSET__WGmHp9CQ__"